import { saveAs } from 'file-saver';
import { SearchParamsOption } from 'ky';

import { GpSurfacesMapParams, GpSurfacesMapResponse } from '../types/gp-surfaces-map';

import { handleRequest, privateClient } from '@data-access';

const GP_SURFACES_MAP_TIMEOUT_MS = 300_000;

function buildSearchParams({
  clause,
  campaignYear,
  organizationIds,
  withProjection,
  uncertainVolumeDiscount,
  metricMode,
}: GpSurfacesMapParams = {}): SearchParamsOption {
  const searchParams: SearchParamsOption = {};
  if (clause) {
    searchParams.clause = clause;
  }
  if (clause === 'new' && campaignYear) {
    searchParams.campaign_year = String(campaignYear);
  }
  if (organizationIds && organizationIds.length > 0) {
    searchParams.organization = organizationIds.join(',');
  }
  if (withProjection) {
    searchParams.with_projection = '1';
  }
  if (uncertainVolumeDiscount) {
    searchParams.uncertain_volume_discount = '1';
  }
  if (metricMode) {
    searchParams.metric_mode = metricMode;
  }
  return searchParams;
}

function parseExportFilename(contentDisposition: string | null): string {
  const match = contentDisposition
    ?.split(';')
    .map((part) => part.trim())
    .find((part) => part.startsWith('filename='));
  if (!match) {
    return 'carte-surfaces.xlsx';
  }
  return match.replace('filename=', '').replace(/"/g, '');
}

export const gpSurfacesMapApi = {
  get: async (params: GpSurfacesMapParams = {}) => {
    return handleRequest<GpSurfacesMapResponse>(
      privateClient
        .extend({ timeout: GP_SURFACES_MAP_TIMEOUT_MS })
        .get('gp-surfaces-map/', { searchParams: buildSearchParams(params) })
        .json(),
    );
  },

  exportExcel: async (params: GpSurfacesMapParams = {}) => {
    const response = await handleRequest(
      privateClient
        .extend({ timeout: GP_SURFACES_MAP_TIMEOUT_MS })
        .get('gp-surfaces-map/export/', {
          searchParams: buildSearchParams(params),
        }),
    );
    const filename = parseExportFilename(
      response.headers.get('content-disposition'),
    );
    const blob = await response.blob();
    saveAs(blob, filename);
  },
};
